import { CheckCircleOutlined, CloudUploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import type { UploadProps } from 'antd';
import { UploadFile as UploadFileAntd, UploadChangeParam } from 'antd/lib/upload/interface';
import React, { useState } from 'react';
import Modal from '../ModalComponent';
import { SectionStyled } from './styles';

interface Props {
  visible: boolean;
  fileName: string;
  onSubmit: (file: File) => Promise<void> | void;
  headersTemplate?: Array<{ label: string; key: string }>;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setFile: (file: File | undefined) => Promise<void> | void;
  file?: File;
}

const { Dragger } = Upload;

const UploadCSV: React.FC<Props> = ({ visible, onSubmit, setVisible, file, setFile }) => {
  const [isUploadSuccessfully, setUploadSuccessfully] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const onClose = () => {
    setVisible(false);
    setFile(undefined);
    setUploadSuccessfully(false);
  };

  const handleDelete = (e: { stopPropagation: () => void }) => {
    setFile(undefined);
    e.stopPropagation();
  };

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit(file as File);
    setFile(undefined);
    setLoading(false);
  };

  const props: UploadProps = {
    name: 'file',
    multiple: true,
    accept: '.xlsx',
    beforeUpload: () => false,
    onChange(info: UploadChangeParam<UploadFileAntd<File>>) {
      setFile(info.file as unknown as File);
    },
  };

  return (
    <Modal
      title="請求書ファイルの更新"
      width={720}
      visible={visible}
      okButton={{
        text: '更新する',
        disabled: file === undefined,
        loading: loading,
        onClick: handleSubmit,
      }}
      cancelButton={
        !isUploadSuccessfully
          ? {
              text: 'キャンセル',
              onClick: onClose,
            }
          : undefined
      }
      onCancel={onClose}
      bodyStyle={{
        backgroundColor: '#f9f8f8',
      }}
      footerStyle={{
        backgroundColor: '#f9f8f8',
        flexFlow: 'row-reverse',
      }}
      headerStyle={{
        color: '#f9f8f8',
        borderBottom: '1px solid #CCCCCC',
      }}
    >
      <SectionStyled>
        {!isUploadSuccessfully ? (
          <div className="form-upload">
            <Dragger {...props}>
              <div className="form-upload-border">
                <div className="file-upload">
                  {file ? (
                    <div className="info-file">
                      <p className="file-name">{file.name} </p>
                    </div>
                  ) : (
                    <>
                      <CloudUploadOutlined className="icon" />
                      <p className="ant-upload-text">
                        アップロードする請求書ファイルをここにドラッグ <br />
                        または
                      </p>
                    </>
                  )}
                  <div className="flex">
                    <button type="button" className="btn-upload" onClick={() => props}>
                      ファイルを選択
                    </button>
                    {file && (
                      <button className="btn-delete" type="button" onClick={(e) => handleDelete(e)}>
                        <DeleteOutlined className="icon-delete-outlined" />
                        <span className="label-delete">ファイルを削除</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </Dragger>
          </div>
        ) : (
          <p className="text-successful">
            <CheckCircleOutlined className="icon" />
            インポートが完了しました！
          </p>
        )}
      </SectionStyled>
    </Modal>
  );
};

export default UploadCSV;
